import AddToAppleWatchButton from "../../../../src/pages/contents/watch-faces/add-button/index.tsx";
import "../../../../src/pages/contents/watch-faces/index.scss";
import * as React from 'react';
export default {
  AddToAppleWatchButton,
  React
};